import React from "react";
import { scaleLinear } from "d3-scale";
import { extent } from "d3-array";
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

import { useInterval } from "../../util/useInterval";
import { getMutationMap } from "../../service/mapData";

import "./mutationMap.css";

const geoUrl =
  "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-50m.json";

const MutationMap = ({ variant, title, setTooltipContent, subtitle = "" }) => {
  const [minDomain, setMinDomain] = React.useState(-1);
  const [maxDomain, setMaxDomain] = React.useState(-1);

  const maxRadius = 8;
  const minRadius = 3;

  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    getMutationMap(variant).then((result) => setData(result));
  }, [variant]);

  React.useEffect(() => {
    const [lowerBound, upperBound] = extent(data.map((val) => val.count));
    setMinDomain(lowerBound);
    setMaxDomain(upperBound);
  }, [data]);

  const fiveMinutes = 1000 * 60 * 5; // in milliseconds
  useInterval(() => {
    console.log("getting map data");
    getMutationMap(variant).then((result) => setData(result));
  }, fiveMinutes);

  function handleClick(countryISO3, geo) {
    console.log("countryISO3 :>> ", countryISO3);
    console.log("geo.properties :>> ", geo.properties);
  }

  return (
    <div>
      <h2 className="map-title">{title}</h2>
      <h3 className="map-title map-subtitle">{subtitle}</h3>
      <ComposableMap data-tip="" projectionConfig={{ scale: 200 }}>
        <ZoomableGroup>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => {
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    onClick={() => {
                      handleClick(geo.properties.ISO_A3, geo);
                    }}
                    style={{
                      default: {
                        fill: "#949494",
                        outline: "none",
                      },
                      hover: {
                        fill: "#949494",
                        cursor: "auto",
                        outline: "none",
                      },
                    }}
                  />
                );
              })
            }
          </Geographies>
          {data.map(({ city, count, country, countryCode, lat, lng }) => {
            let radius = Math.max(
              minRadius,
              Math.ceil((count / maxDomain) * maxRadius)
            );
            if (isNaN(radius)) {
              radius = 0;
            }
            return (
              <Marker key={city} coordinates={[lng, lat]}>
                <circle
                  r={radius}
                  fill={scaleLinear()
                    .domain([minDomain, maxDomain])
                    .range(["#ffedea", "#ff5233"])(count)}
                  opacity={0.5}
                  stroke="#275451"
                  strokeWidth={2}
                  className="marker"
                  onMouseEnter={() => {
                    setTooltipContent(`${city}, ${country}: ${count} variant`);
                  }}
                  onMouseLeave={() => {
                    setTooltipContent("");
                  }}
                >
                  <animate
                    attributeType="CSS"
                    attributeName="stroke-width"
                    begin="0s"
                    dur="1.2s"
                    repeatCount="indefinite"
                    from={5}
                    to={0}
                  />
                  <animate
                    attributeType="CSS"
                    attributeName="stroke-opacity"
                    begin="0s"
                    dur="1.2s"
                    repeatCount="indefinite"
                    from="1"
                    to="0.2"
                  />
                </circle>
              </Marker>
            );
          })}
        </ZoomableGroup>
      </ComposableMap>
    </div>
  );
};

export default React.memo(MutationMap);
